<template>
  <div class="search-page">
    <el-form :model="searchObj" style="margin-top: 30px;">
      <el-input id="searchInput" ref="searchInput" size="large" class="input" prefix-icon="el-icon-search" :maxlength="maxSize"
                placeholder="请输入内容" v-model="searchObj.searchText" @change="search" @blur="search">
      </el-input>
      <div class="inline-block v-middle">
        <el-button class="search-button" type="primary" @click="search">搜索</el-button>
      </div>
    </el-form>
    <el-container>
      <el-main>
        <el-tabs :v-model="searchType.toString()" class="nav-tab" @tab-click="changeTab" >
          <el-tab-pane v-for="item in types"
                       :label="getTabTitle(item)" :name="getTabName(item)">

            <el-table class="no-line-table" :header-cell-style="{ background: 'transparent', color: 'transparent' }"
                      :data="tableList" :show-header="false" @row-click="clickRow" empty-text="" sele>
              <template slot="empty">
                <el-empty v-if="tableList.length === 0" description="没有找到你期望的内容，换个关键词试试吧"></el-empty>
              </template>
              <el-table-column prop="doc_id">
                <template slot-scope="scope">
                  <p style="font-weight: bold" v-html="showContent(scope.row.title)"></p>
                  <p v-html="showContent(scope.row.content)"></p>
                </template>
              </el-table-column>
            </el-table>

          </el-tab-pane>
        </el-tabs>
      </el-main>
      <el-footer>
        <el-row :gutter="20" style="margin-left: 10%; width: 75%">
          <el-col :span="10">
            <div style="display: inline-block">
              <span>没找到答案？请到问题反馈去提问</span>
              <el-button size="mini" type="primary" plain round @click="toTicket($event)">我要提问</el-button>
            </div>
          </el-col>
          <el-col :span="14">
            <el-pagination style="float: right"
                           class="paging"
                           @size-change="handleSizeChange"
                           @current-change="handlePageChange"
                           :page-sizes="[10, 50, 100, 200]"
                           :current-page.sync="pageNo"
                           :page-size="pageSize"
                           :total="total"
                           :hide-on-single-page="this.total <= 0"
                           layout="prev, pager, next, total">
            </el-pagination>
            <div>
              <el-drawer title="问答详情" size="30%" :visible.sync="showDetail" direction="rtl">
                <div>
                  <hot-ticket-detail :id="selectedId"></hot-ticket-detail>
                </div>
              </el-drawer>
            </div>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
  </div>

</template>

<script>
import HotTicketDetail from "../ticket/hot-ticket-detail";

export default {
  name: "search",
  components: {HotTicketDetail},
  data() {
    return {
      searchObj: {
        searchText: '',
      },
      searchType: 0,
      tableList: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      types: this.$config.searchTypes,
      data: {
        route_url: '',
      },
      selectedId: null,
      showDetail: false,
      maxSize: 30,
    }
  },

  watch: {
    '$route.query'(newVal, oldVal) {
      this.getSearchKey(newVal.key)
      this.searchRequest();
    }
  },

  mounted() {
    this.getSearchKey(this.$route.query.key)
    this.search();
    document.getElementById("searchInput").focus();
  },

  methods: {

    getSearchKey(key) {
      this.searchObj.searchText = key;
      if (key.length > this.maxSize) {
        this.searchObj.searchText = key.substr(0, this.maxSize);
      }
    },

    getTabTitle(item) {
      return `${item.description}(${item.count})`
    },
    getTabName(item) {
      if (item === undefined || item.type === undefined) {
        return '';
      }
      return item.type.toString();
    },

    showContent(content) {
      let title = content.replaceAll ('<em>','<span style="color: #F16222;">');
      title = title.replaceAll ('</em>','</span>');
      return title;
    },
    clickRow(row, column, event) {
      if (row.search_type === 3) {
        this.showDetail = true;
        this.selectedId = row.business_id;
        return;
      }
      if (row.route_url !== undefined) {
        const {href} = this.$router.resolve({path: row.route_url});
        window.open(href, '_blank');
      }
    },
    handlePageChange() {
      this.refreshList();
    },
    handleSizeChange() {
      this.refreshList();
    },

    toTicket(event) {
      let target = event.target;
      if(target.nodeName === 'SPAN' || target.nodeName === 'I'){
        target = event.target.parentNode;
      }
      target.blur();
      const {href} = this.$router.resolve({path: '/help/tickets'});
      window.open(href, '_blank');
    },

    changeTab(tab, event) {
      this.searchType = Number.parseInt(tab.name);
      this.pageNo = 1;
      this.refreshList();
    },

    refreshList() {
      let key = this.searchObj.searchText;
      if (key !== undefined && key.length > 0) {
        this.searchList(key);
      }
    },


    search() {
      let key = this.searchObj.searchText;
      this.pageNo = 1;
      if (key !== undefined && key.length > 0) {
        this.$router.replace({path: `/help/search?key=${key}`});
      }
      this.searchRequest();
    },

    searchRequest() {
      let key = this.searchObj.searchText;
      if (key !== undefined && key.length > 0) {
        this.searchCount(key);
      }
    },

    searchList(key) {
      if (this.isLoading) {
        return;
      }
      this.showCommonLoading();
      this.$axios.post('/ajax/doc/search/list', {
        keyword: key,
        search_type: this.searchType,
        page_no: this.pageNo,
        page_size: this.pageSize,
      }).then(res => {
        this.hideCommonLoading();

        if (res.data.ret === 0) {
          this.total = res.data.data.total | 0;
          if (this.total > 0) {
            this.tableList = res.data.data.list;
          } else {
            this.tableList = [];
          }
        }
      }).catch(ex => {
        this.hideCommonLoading();
      });
    },
    searchCount(key) {
      if (this.isLoading) {
        return;
      }
      this.showCommonLoading();
      this.$axios.post('/ajax/doc/search/type/count', {
        keyword: key,
      }).then(res => {
        this.hideCommonLoading();
        if (res.data.ret === 0) {
          this.types = res.data.data;
          this.searchList(key);
        }
      }).catch(ex => {
        this.hideCommonLoading();
      });
    },
  }
}
</script>
<style lang="scss" scoped>

/deep/ .el-tabs__item {
  font-weight: bold;
  font-size: 15px;
}

.search-page {
  width: 1200px;
  padding: 20px 0 30px 40px;
  margin: 0 auto;
}

.input {
  width: 65%;
  font-size: 15px;
  margin-left: 10%;
}

.nav-tab {
  width: 75%;
  margin-left: 10%;
  margin-top: 25px;
  padding-bottom: -10px;
}

.no-line-table {
  cursor: pointer;
  .el-table th, .el-table tr,.el-table td{
    border: 0;
    background-color: transparent;
  }
  /* 去掉上面的线 */
  /deep/ .el-table th.is-leaf{
    border: none;
  }

  /deep/ .el-table__row:nth-child(2n) {
    background: transparent;
  }
}

.highlight-style {
  color: #F16222;
}


.search-button {
  display: inline-block;
  margin-bottom: 3px;
  width: 110px;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  text-align: center;
  vertical-align: middle;
  font-weight: bold;
}

.search-page-title {
  width: 100%;
  height: 32px;
  line-height: 32px;
  font-size: 28px;
  color: #212121;
  text-align: center;
  margin: 10px 10px;
  padding-top: 30px;
  padding-bottom: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/help/search.vue